
import { useEffect } from 'react';

function Cursor() {
  useEffect(() => {
    // Wait for the DOM to be fully loaded
    const cursor = document.querySelector('.cursor') as HTMLElement | null;

    // Ensure the .cursor element exists
    if (!cursor) {
      console.warn('.cursor element not found');
      return;
    }

    const link = document.querySelectorAll('.hover-this');

    // Function to handle hover animations
    const animateit = function (this: any, e: any) {
      const hoverAnim = this.querySelector('.hover-anim') as HTMLElement | null;
      if (!hoverAnim) return;

      const { offsetX: x, offsetY: y } = e;
      const { offsetWidth: width, offsetHeight: height } = this;
      const move = 25;
      const xMove = (x / width) * (move * 2) - move;
      const yMove = (y / height) * (move * 2) - move;

      hoverAnim.style.transform = `translate(${xMove}px, ${yMove}px)`;
      if (e.type === 'mouseleave') hoverAnim.style.transform = '';
    };


    // Function to update cursor position
    const editCursor = (e: MouseEvent) => {
      const { clientX: x, clientY: y } = e;
      cursor.style.left = `${x}px`;
      cursor.style.top = `${y}px`;
    };
    
    // Add event listeners for hover elements
    link.forEach((b) => {
      b.addEventListener('mousemove', animateit);
      b.addEventListener('mouseleave', animateit);
    });

    // Add event listener for cursor movement
    window.addEventListener('mousemove', editCursor);

    // Handle hover effects on interactive elements
    const interactiveElements = document.querySelectorAll('a, .cursor-pointer');
    interactiveElements.forEach((el) => {
      el.addEventListener('mouseenter', () => cursor.classList.add('cursor-active'));
      el.addEventListener('mouseleave', () => cursor.classList.remove('cursor-active'));
    });

    // Cleanup on component unmount
    return () => {
      link.forEach((b) => {
        b.removeEventListener('mousemove', animateit);
        b.removeEventListener('mouseleave', animateit);
      });
      window.removeEventListener('mousemove', editCursor);
      interactiveElements.forEach((el) => {
        el.removeEventListener('mouseenter', () => cursor.classList.add('cursor-active'));
        el.removeEventListener('mouseleave', () => cursor.classList.remove('cursor-active'));
      });
    };
  }, []);

  return <div className="cursor"></div>;
}

export default Cursor;
